import _styled from "styled-components";
import React, { memo, useEffect, useState } from 'react';
import { useResponsiveBreakPoints } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CircularProgressBar = /*#__PURE__*/memo(function (_ref) {
  var progress = _ref.progress,
      label = _ref.label;

  // Ensure progress is between 0 and 100
  var _useState = useState(0),
      progressValue = _useState[0],
      setProgressValue = _useState[1];

  var _useState2 = useState(''),
      progressLabel = _useState2[0],
      setProgressLabel = _useState2[1];

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  var size = isDesktop ? 136 : 93;
  var radius = size / 2; // Half of the width/height of the circle

  var circumference = 2 * Math.PI * radius;
  var angle = progressValue / 100 * 360;
  var dashOffset = circumference - angle / 360 * circumference;
  useEffect(function () {
    setProgressValue(Math.min(Math.max(progress, 0), 100));

    if (label) {
      setProgressLabel(label);
    }
  }, [label, progress]);
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    style: {
      width: size,
      height: size
    },
    children: [/*#__PURE__*/_jsxs(_StyledSvg, {
      width: radius * 2,
      height: radius * 2,
      children: [/*#__PURE__*/_jsx(_StyledCircle, {
        cx: radius,
        cy: radius,
        r: radius - 4 // Adjust for stroke width
        ,
        strokeWidth: "8",
        fill: "transparent"
      }), /*#__PURE__*/_jsx(_StyledCircle2, {
        cx: radius,
        cy: radius,
        r: radius - 4 // Adjust for stroke width
        ,
        strokeWidth: "8",
        fill: "transparent",
        strokeDasharray: "".concat(circumference, " ").concat(circumference),
        strokeDashoffset: dashOffset,
        transform: "rotate(-90 ".concat(radius, " ").concat(radius, ")") // Rotate to start from 0 degrees
        ,
        strokeLinecap: "round"
      })]
    }), /*#__PURE__*/_jsx(_StyledDiv2, {
      children: /*#__PURE__*/_jsx(_StyledDiv3, {
        children: progressLabel
      })
    })]
  });
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "circular-progress-bar___StyledDiv",
  componentId: "sc-wetedi-0"
})({
  "position": "relative"
});

var _StyledSvg = /*#__PURE__*/_styled("svg").withConfig({
  displayName: "circular-progress-bar___StyledSvg",
  componentId: "sc-wetedi-1"
})({
  "position": "absolute",
  "top": "0px",
  "right": "0px",
  "bottom": "0px",
  "left": "0px"
});

var _StyledCircle = /*#__PURE__*/_styled("circle").withConfig({
  displayName: "circular-progress-bar___StyledCircle",
  componentId: "sc-wetedi-2"
})({
  "stroke": "#e2d8f3"
});

var _StyledCircle2 = /*#__PURE__*/_styled("circle").withConfig({
  displayName: "circular-progress-bar___StyledCircle2",
  componentId: "sc-wetedi-3"
})({
  "stroke": "#693eb5"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "circular-progress-bar___StyledDiv2",
  componentId: "sc-wetedi-4"
})({
  "position": "absolute",
  "top": "0px",
  "right": "0px",
  "bottom": "0px",
  "left": "0px",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "circular-progress-bar___StyledDiv3",
  componentId: "sc-wetedi-5"
})({
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "1.5rem",
    "lineHeight": "2.25rem"
  }
});